import React from 'react';

import Box from 'grommet/components/Box';

import './styles.scss';

export default function({ children }) {
  if (children) {
    return (
      <Box className="error" pad={{ vertical: 'small' }}>
        {children}
      </Box>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/elements/Error/index.js